import ButtonOnly from "../button/buttonOnly";
import InputText from "../inputText/inputText";
import "./footer.css";
function FooterButton({
  handleName,
  setHandleName,
  handleName2,
  setHandleName2,
  ftIdName,
  buttonClass,
  btnClass,
  buttonValue = "미션 시작하기",
  onFinish,
  disabled,
}) {
  buttonClass = buttonClass ?? btnClass ?? "inputBtn03 mt16";

  return (
    <div id={ftIdName}>
      <InputText
        textClass="input02"
        textValue="팀명을 입력하세요."
        handleName={handleName}
        setHandleName={setHandleName}
      />
      <InputText
        textClass="input02 mt16"
        textValue="입장 코드를 입력하세요."
        handleName={handleName2}
        setHandleName={setHandleName2}
      />
      <ButtonOnly
        btnValue={buttonValue}
        btnClass={buttonClass}
        onFinish={onFinish}
        disabled={disabled}
      />
    </div>
  );
}

export default FooterButton;
